export default __webpack_public_path__ + "static/media/phone-light.12579855.jpg";